module.exports = __webpack_public_path__ + "img/invitationZh.052e42bb.jpg";